import { render } from "./Displacement.vue?vue&type=template&id=b57a5768&ts=true"
import script from "./Displacement.vue?vue&type=script&lang=tsx"
export * from "./Displacement.vue?vue&type=script&lang=tsx"

import "./Displacement.vue?vue&type=style&index=0&id=b57a5768&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__